<style lang="scss">
.temp-detail .ivu-select-disabled {
	.ivu-tag-checked {
		cursor: default;
		border: none;
		background-color: transparent;
	}
	.ivu-icon-ios-close-empty {
		display: none;
	}
}
.temp-detail .ivu-form-item {
	margin-bottom: 12px;
}
</style>

<template>
	<div>
		<compFormQuery :formdata="getBase" :value="formData"></compFormQuery>
		<vLoading loading size="large" fix v-if="loading"></vLoading>
	</div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import {
	HttpTemplate
} from '@/service/boss/allot';

export default {
	props: ['id'],
	components: {
		compWrapper: () => import("@components/templates/wrapper"),
		compFormQuery: () => import("@components/templates/formquery"),
	},
	data() {
		return {
			loading: false,
			formData: {
				name: '',
				description: '',
				orgWarehouseId: '',
				safetyStock: '',
				priority: '',
				accountFlag: '',
				code: '',
				property: 'NORMAL',
				status: 'ACTIVE',
				isDefault: 0,
			},
		}
	},
	created() {
		this.getDetail();
	},
	computed: {
		...mapGetters('boss', ['warehouses', 'accountFlag']),
		getBase() {
			const { orgWarehouseId, property, isDefault, status } = this.formData;
			const orgWarehouseName = this.warehouses.filter(function (item) {
				return orgWarehouseId.indexOf(item.id) > -1
			})
			return [{
				label: this.$t('fbb.accountmanage.template_name',{defaultValue:'模板名称'}),
				key: "name",
			}, {
				label: this.$t('erp.virtualstore.correspwarehouse',{defaultValue:'对应仓库'}),
				key: "orgWarehouseId",
				span: 24,
				render(h) {
					return orgWarehouseName.map(function (item) {
						return <span class='margin-right-15'>{item.title}({item.code})</span>
					})
				}
			},
			{
				label: this.$t('erp.virtualstore.safeQuantity',{defaultValue:'安全库存'}),
				key: "safetyStock",
			},
			{
				label: this.$t('bi.work.task_priority',{defaultValue:'优先级'}),
				key: "priority",
				tip: '<span class="color-error padding-left-20">'+this.$t('erp.virtualstore.hightnumpriority',{defaultValue:'数字越大，优先级越高'})+'</span>'
			},
			{
				label: this.$t('erp.virtualstore.description',{defaultValue:'模板描述'}),
				key: "description"
			},
			{
				label: this.$t('erp.virtualstore.property',{defaultValue:'模板属性'}),
				key: "property",
				valueText: ({ 'NORMAL': this.$t('fbb.bill.account_common',{defaultValue:'正常'}), 'SFP': 'SFP' })[property]
			},
			{
				label: this.$t('erp.virtualstore.isDefault',{defaultValue:'默认模板'}),
				key: "isDefault",
				valueText: (['否', '是'])[isDefault]
			},
			{
				label: this.$t('erp.virtualstore.tempstatus',{defaultValue:'模板状态'}),
				key: "status",
				valueText: ({ 'ACTIVE': this.$t('global.common.effective', { defaultValue: '有效' }), 'INACTIVE': this.$t('fbb.accountmanage.loss_effect', { defaultValue: "失效" }) })[status]
			},
			{
				label: this.$t('erp.virtualstore.amazonaccount',{defaultValue:'亚马逊账号'}),
				key: "accountFlag",
			},
			{
				label: this.$t('erp.virtualstore.amazonname',{defaultValue:'亚马逊模板名称'}),
				key: "code",
			},
			];
		},
	},
	methods: {
		async getDetail() {
			this.loading = true;
			HttpTemplate({
				id: this.id
			}).then(res => {
				const data = res.data || {};
				this.formData = data;
				this.formData.orgWarehouseId = (data.items || []).map((item) => {
					return item.warehouseId;
				});
				this.loading = false;
			}, err => {
				this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
				this.loading = false;
			})
		}
	}
}
</script>
